import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UserActions } from '../../actions';
import { RegularPage } from '../Templates';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Button, TextField, Grid, InputAdornment, Icon } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    }
});

class AllUsersPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: ""
        }

        this.getUserAccountAccess = this.getUserAccountAccess.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }
    
    componentDidMount() {
        const {dispatch} = this.props;
        dispatch(UserActions.getAllUsers());
    }

    handleSearch(e) {
        this.setState({search: e.target.value});
    }

    getUserAccountAccess(userID) {
        const {dispatch} = this.props;

        return () => {
            dispatch(UserActions.getAccountAccess({userID: userID}));
        }
    }

    getTableRows() {
        const {users} = this.props;
        const {search} = this.state;

        // return empty row because children is required in TableBody
        if(!users || !users.list) return (<TableRow></TableRow>);

        let list = Object.values(users.list);
        
        if(search.trim().length > 0) {
            list = list.filter((item) => {
                let {name, phone, email} = item;
                return (name && name.includes(search)) || (phone && phone.includes(search)) || (email && email.includes(search));
            });
        }
        
        return list.map((item) => (
            <TableRow key={item._id}>
                <TableCell>
                    {item.name}
                </TableCell>
                <TableCell>
                    {item.email}
                </TableCell>
                <TableCell>
                    {item.phone}
                </TableCell>
                <TableCell numeric>
                    {item.events.length}
                </TableCell>
                <TableCell>
                    <Button variant="contained" color="secondary" fullWidth onClick={this.getUserAccountAccess(item._id)}>
                        Get access
                    </Button>
                </TableCell>
            </TableRow>
        ));
    }

    render () {
        const {classes} = this.props;

        return (
            <RegularPage>
                <Grid item xs={4}>
                    <TextField
                        id="search"
                        label="Search by name email or phone"
                        value={this.state.search}
                        onChange={this.handleSearch}
                        margin="normal"
                        classes={classes.search}
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Icon>search</Icon>
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>
                <Paper className={classes.root}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell numeric>Events</TableCell>
                                <TableCell>Get account access</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.getTableRows()}
                        </TableBody>
                    </Table>
                </Paper>
            </RegularPage>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        users: state.userReducer
    }
}

const AllUsersPageWithRedux = withStyles(styles)(connect(mapStateToProps)(AllUsersPage));

export {AllUsersPageWithRedux as AllUsersPage};


// WEBPACK FOOTER //
// ./src/components/AllUsersPage/AllUsersPage.jsx